// These are subject to change

const colorPalette = {
  altBlack: '#333333',
  black: '#000000',
  matteBlack: '#252122',
  fontGray: '#828282',
  offWhite: '#FAFAFA',
  darkBlue: '#055445',
  error: '#FF6D6D',
  warning: '#EB5757',
  grey: '#6A6A6A',
  lightBlue: '#E3EEFF',
  lightGrey: '#B1B1B1',
  lighterGrey: '#CDCDCD',
  white: '#FFFFFF',
  paleYellow: '#FFBD00',
  shadow: '#e5e5e5c2',
  textGrey: '#AAAAAA',
  boxShadow: '#10101059',
  mediumGrey: '#4F4F4F',
  warmBlue: '#2F80ED',
  davysGrey: '#8B8B8B',
  dimGrey: '#959595',
  subHeadingGrey: '#828282',
  buttonShadow: '#0a4ab72b',
  rejected: '#EB5757',
  pending: '#F2994A',
  approved: '#15CF74',
  success: '#15CF74',
  inherit: 'inherit',
  lightSuccess: '#E4FBF0',
  neutralBlack: '#25282B',
  neutralDivider: '#E8E8E8',
  inActiveBlue: 'rgba(10, 74, 183, 0.41)',
  lightGreen: '#E4FFE1',
  mango: '#D67A20',
  landingBackground: '#E4FFE1',
};

export type FontSizeType = 'xxsmall' | 'xsmall' | 'small' | 'regular' | 'medium' | 'large' | 'xlarge' | 'xxlarge' | 'xxxlarge' | 'xxxxlarge' | 'extralarge'| 'xextralarge';

// eslint-disable-next-line
type FontSizeOptions = { [key in FontSizeType]: string };

const fontSizes: FontSizeOptions = {
  xxsmall: '0.5rem',
  xsmall: '0.625rem',
  small: '0.75rem',
  regular: '0.813rem',
  medium: '0.875rem',
  large: '1rem',
  xlarge: '1.25rem',
  xxlarge: '1.5rem',
  xxxlarge: '1.75rem',
  xxxxlarge: '2rem',
  extralarge: '2.6rem',
  xextralarge: '3.4rem',
};

export type FontWeightType = 'xtraLight' | 'light' | 'thin' | 'normal' | 'medium' | 'semiBold' | 'bold' | 'extraBold' | 'black';

// eslint-disable-next-line
type FontWeightOptions = { [key in FontWeightType]: number };

const fontWeights: FontWeightOptions = {
  xtraLight: 100,
  light: 200,
  thin: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
};

const typography = {
  primary: 'Sora',
  secondary: 'Galano',
};

const Theme = {
  colorPalette,
  fontSizes,
  fontWeights,
  typography,
};

export default Theme;
